import React, { useEffect } from "react";

import PluginLoader from "@views/plugins/PluginLoader";


const PLUGIN_KEY = "br_localization_plugins";
export default function BrandLocalizationPlugins() {
    useEffect(() => {
        PluginLoader(PLUGIN_KEY);
    }, [])

    return (
        <div id={PLUGIN_KEY}> </div>
    );
}